module.exports = __webpack_public_path__ + "static/media/ios-close.91fc43e1.svg";